import { environment } from '../../environments/environment';

/**
 * Loads Google Analytics 4 (gtag) with the environment's Firebase
 * measurementId — live and staging carry different GA4 streams. Uses gtag
 * directly instead of the full Firebase SDK to keep the bundle lean; it
 * reports into the same GA4 property that Firebase links to.
 *
 * No-ops on localhost / preview hosts and when no measurementId is set, so it
 * only ever runs on the real Firebase-hosted deployments.
 */
export function initSiteAnalytics(): void {
  const id = environment.firebase?.measurementId;
  if (!id) return;

  const h = window.location.hostname;
  const isLocal =
    h === 'localhost' ||
    h === '127.0.0.1' ||
    h.startsWith('192.168.') ||
    h.endsWith('.local');
  if (isLocal) return;

  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(s);

  const w = window as unknown as {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  };
  w.dataLayer = w.dataLayer || [];
  w.gtag = function gtag(...args: unknown[]) {
    w.dataLayer.push(args);
  };
  w.gtag('js', new Date());
  w.gtag('config', id);
}
